import { ListItem, IconButton, ListItemText, Divider } from '@mui/material';
import { Clear } from '@mui/icons-material';

interface ListItemWithDeleteProps {
  onRemoveClick: () => void;
  label: string;
}

export default function ListItemWithDelete({ onRemoveClick, label }: ListItemWithDeleteProps) {
  return (
    <>
      <ListItem
        secondaryAction={
          <IconButton edge="end" onClick={onRemoveClick}>
            <Clear />
          </IconButton>
        }
        sx={{ p: 0 }}
      >
        <ListItemText primary={label} />
      </ListItem>
      <Divider />
    </>
  );
}
